// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { Link, useLocation, withRouter, RouteComponentProps } from "react-router-dom";
import logo from "../../../../assets/images/hero.png";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { generateKey } from "../../../../common/crypto";
import { toast } from "react-toastify";
import IAuthenticationActions, * as authenticationActions from "../../../../redux/actions/authenticationActions";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import LoadingOverlay from "react-loading-overlay";
import { IChepIdList,IMChepIdList } from "../../../../models/applicationState";
import IUserDefinedActions, * as userDefinedActions from "../../../../redux/actions/userDefinedActions";
/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @param param0 - {
 *      project - IProject
 * }
 */
export interface ILoginProps extends RouteComponentProps, React.Props<Login> {
    authenticationActions: IAuthenticationActions;
    appSecurityTokenAction: IApplicationActions;
    userDefinedActions: IUserDefinedActions;
}

export interface ILoginState {
    email: string;
    password: string;
    loadModal: boolean;
    spinnerString: string;
    input: string;
}

function mapDispatchToProps(dispatch) {
    return {
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
        appSecurityTokenAction: bindActionCreators(applicationActions, dispatch),
        userDefinedActions:bindActionCreators(userDefinedActions, dispatch), 

    };
}

@connect(null, mapDispatchToProps)

class Login

    extends React.Component<ILoginProps, ILoginState> {
    public state: ILoginState = {
        email: "",
        password: "",
        loadModal: false,
        spinnerString: "",
        input: "password"
    };

    public componentDidMount() {
        this.props.authenticationActions.userLoggedOut();
        localStorage.setItem("signInUserSession_Domain", "CHEP-DEV");
    }

    // public const history = useHistory();

    public onUserLogin = async () => {
        //
        let chepidList=IChepIdList;
        let chepidMList = IMChepIdList;
        
        this.setState({ loadModal: true, spinnerString: "Logging in..." });
        let userEmail=this.state.email;
        const requestBody = {
            username: this.state.email,
            password: this.state.password,
        };
        const self = this;
        this.props.authenticationActions.getLoggedInUser(requestBody).then(async (loginData: any) => {
           // self.setState({ loadModal: false });
            if (loginData.status === 200) {
                debugger;
                 this.setState({  spinnerString: "loading features..." });
                // if (loginData.user.extension_tenantuid === "1") {
                localStorage.setItem("signInUserSession", JSON.stringify(loginData));
                let useroid = loginData.user.oid;
                //make a call to check feature access
                let usersFeatures  = loginData?.features;   
             
                let userFeatures =1;
                let role="";
                console.log("User Features==>"+usersFeatures);
                
                this.setState({ loadModal: false});           
                let featuresCount:number = usersFeatures?usersFeatures.length:0;
                if(featuresCount>0)
                {
                    role="C";
                }                
                else
                {
                    role="G";
                }
                localStorage.setItem("ChepRole", role);
                localStorage.setItem("ChepFeatures", JSON.stringify(usersFeatures));
                
                const appSettings = { securityTokens: [{ name: 'token', key: generateKey() }] };
                await this.props.appSecurityTokenAction.saveAppSettings(appSettings);
                                
                if(role==="C")
                {                    
                    self.props.history.push("/DocumentManagement");
                }
                else
                {
                    self.props.history.push("/create-model");
                }
                //if(userEmail.toLocaleLowerCase()==="vijayak.in@mouritech.com")
               /* if(chepidList.indexOf(userEmail.toLocaleLowerCase())>-1|| chepidMList.indexOf(userEmail.toLocaleLowerCase())>-1)
                {
                self.props.history.push("/DocumentManagement");
                }
                else
                {
                self.props.history.push("/create-model");
                }*/
                          
                
                
            } else {
                if (loginData.status === 400) {
                    this.props.authenticationActions.userLoggedOut();
                    toast.warn("The username or password provided in the request are invalid.", { position: toast.POSITION.TOP_CENTER });
                } else {
                    toast.warn("The username or password provided in the request are invalid.", { position: toast.POSITION.TOP_CENTER });
                }
            }
        }).catch((err) => {
            this.props.authenticationActions.userLoggedOut();
            toast.warn("Some thing went wrong", { position: toast.POSITION.TOP_CENTER });
            self.setState({ loadModal: false });
        });
    }

    private showPassword = (inputTypeValue) => {
        const inputType = inputTypeValue === "password" ? "test" : "password";
        this.setState({ input: inputType });
    } 

    public onUserLogin_old = async () => {
        //
        let chepidList=IChepIdList;
        let chepidMList = IMChepIdList;
        
        this.setState({ loadModal: true, spinnerString: "Logging in..." });
        let userEmail=this.state.email;
        const requestBody = {
            email: this.state.email,
            password: this.state.password,
        };
        const self = this;
        this.props.authenticationActions.getLoggedInUser(requestBody).then(async (loginData: any) => {
            self.setState({ loadModal: false });
            if (loginData.status === 200) {
                debugger;
                // if (loginData.user.extension_tenantuid === "1") {
                localStorage.setItem("signInUserSession", JSON.stringify(loginData));
                let useroid = loginData.user.oid;
                //make a call to check feature access
                // let usersFeatures  = await this.props.userDefinedActions.getBusinessUserDetailsbyId(useroid);   
                // console.log(usersFeatures)
                // if(usersFeatures)
                // {
                    
                // }
                const appSettings = { securityTokens: [{ name: 'token', key: generateKey() }] };
                await this.props.appSecurityTokenAction.saveAppSettings(appSettings);
                
                //if(userEmail.toLocaleLowerCase()==="vijayak.in@mouritech.com")
                if(chepidList.indexOf(userEmail.toLocaleLowerCase())>-1|| chepidMList.indexOf(userEmail.toLocaleLowerCase())>-1)
                {
                self.props.history.push("/DocumentManagement");
                }
                else
                {
                self.props.history.push("/create-model");
                }
            } else {
                if (loginData.status === 400) {
                    this.props.authenticationActions.userLoggedOut();
                    toast.warn("The username or password provided in the request are invalid.", { position: toast.POSITION.TOP_CENTER });
                }  else {
                    toast.warn("Somethimg went wrong", { position: toast.POSITION.TOP_CENTER });
                }
            }
        }).catch((err) => {
            this.props.authenticationActions.userLoggedOut();
            toast.warn("Some thing went wrong", { position: toast.POSITION.TOP_CENTER });
            self.setState({ loadModal: false });
        });
    }
    public render() {
        return (
            <div className="login-outer">
                <div className="middle">
                    <LoadingOverlay
                        active={this.state.loadModal}
                        spinner
                        className="wrap-queue-height"
                        text={this.state.spinnerString}
                    >
                        <div className="container">
                            <div className="row mt-5  justify-content-center">
                                <div className="col-md-5">
                                    <div className="register-box">
                                        <div className="text-center">
                                            <a className="navbar-brand" href="#">
                                                <img src={logo} className="img-fluid logo" />
                                            </a>
                                            <br /> <br />
                                        </div>
                                        <div>
                                            <h5> Login </h5>
                                            <hr />
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label>Email </label>
                                                <input type="text" className="form-control" name="email"
                                                    placeholder="Enter Email Address"
                                                    onChange={(event) => this.setState({ email: event.target.value })}></input>
                                            </div>

                                            <div className="col-md-12">
                                                <label>Password </label>
                                                <input className="form-control" name="password"
                                                    placeholder="Password"
                                                    type={this.state.input}
                                                    onChange={(event) => this.setState({ password: event.target.value })}></input>
                                                     <span role="button" onClick={() => this.showPassword(this.state.input)}
                                                    className={this.state.input === "password" ? "fa fa-fw fa-eye field-icon" : "fa fa-fw fa-eye-slash field-icon"}></span>

                                                <Link to="/change-password" className="forgot float-right"> Forgot password? </Link>
                                            </div>
                                        </div>
                                        <div className="row mt-5 justify-content-center">
                                            <div className="col-md-12">
                                                <button className="btn btn-block "
                                                    onClick={() => this.onUserLogin()}> Login
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </LoadingOverlay>

                </div>

            </div>

        );
    }
}

export default withRouter(Login);
